/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ports: NonNullable<unknown>, countries: NonNullable<unknown> }} Services_Where_TitleInputs */



/**
* | output |
* | --- |
* | "More than {ports} ports in {countries}+ countries." |
*
* @param {Services_Where_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_where_title = /** @type {((inputs: Services_Where_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Where_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`覆盖 ${i?.countries}+ 个国家的超过 ${i?.ports} 个港口。`)
	return /** @type {LocalizedString} */ (`More than ${i?.ports} ports in ${i?.countries}+ countries.`)
});